import { mapState, mapActions } from 'pinia';
import { useAccountStore } from '@/stores/account';

export default {
    computed: {
        ...mapState(useAccountStore, {
            account: 'account',
            accountLoading: 'loading',
            accountError: 'error',
        }),
        accountStore() {
            return useAccountStore();
        },
        loading() {
            return this.accountLoading;
        },
        error() {
            return this.accountError;
        }
    },
    methods: {
        ...mapActions(useAccountStore, ['getAccount']),
        async fetchAccount() {
            await this.getAccount();
            if(process.env.VUE_APP_HAS_ONBOARDING === 'true' && (this.account?.onboarding_status === 0 || this.account?.onboarding_status > 1)) {
                this.$router.push({ name: 'onboarding' });
            } 
            
            // TEST MODE - ENABLE IN PRODUCTION
            // else if (process.env.VUE_APP_HAS_ONBOARDING === 'true' && this.$router.currentRoute.value.name === 'onboarding') {
            //     this.$router.push({ name: process.env.VUE_APP_DEFAULT_ROUTE });
            // }
        }
    },
    async created() {
        await this.fetchAccount();
    },
    unmounted() {
        this.accountStore.resetState();
    }
};
